module.exports = __webpack_public_path__ + "img/422509_C89536_824512_0A0604-256px.4115699b.png";